module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-create text-dark"
  }, [_c('DModal', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "task-create__modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "task-create__header",
    class: {
      'task-create__header--create-subject': _vm.canSchedule
    },
    style: ({
      'backgroundColor': _vm.color
    })
  }, [_c('h3', [(_vm.name.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']))]) : _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "task-create__close icon__bg-circle",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('form', {
    staticClass: "task-create__body",
    attrs: {
      "id": "task-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "task-create__form"
  }, [_c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticClass: "input-group input-group__title"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['task_title']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "name",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['name']
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n[_vm.locale]['ex_task']
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isArbeidstidsplanActivated) ? _c('div', {
    staticClass: "input-group input-group__preparation"
  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preparation),
      expression: "preparation"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.preparation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preparation = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_user']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "USER",
      "preSelectedItems": _vm.calendars,
      "showTags": true,
      "itemsThatCantBeDeleted": _vm.usersWithEvents
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1), _vm._v(" "), (!_vm.editTask) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type']))]), _vm._v(" "), _c('SubjectFormSubjectType', {
    attrs: {
      "calendar-type": "user",
      "subject-type": _vm.subjectType,
      "isInTasks": true
    },
    on: {
      "change": _vm.setSubjectType
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_as']) + " "), _c('span', {
    staticClass: "pill pill--grey hint--top-right",
    attrs: {
      "aria-label": "Vælg briktype for at ændre"
    }
  }, [_vm._v(_vm._s(_vm.hoursType))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['hours']
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('hours')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()])])]), _vm._v(" "), (!_vm.editTask) ? _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "create-as-subject"
  }, [_c('div', {
    staticClass: "create-as-subject__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.canSchedule = !_vm.canSchedule
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.canSchedule,
      "allowChanges": false
    },
    on: {
      "changed": _vm.setIsCreateAsSubject
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['can_be_scheduled']))])], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.canSchedule) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['duration']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.duration),
      expression: "duration",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "d-input",
    class: {
      'input--error': _vm.formErrors['duration']
    },
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.duration)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('duration')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formErrors['duration']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['duration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.isCreateInOtherCalendarAnOption && !_vm.editTask) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_in_calendar']))]), _vm._v(" "), _c('SelectOtherCal', {
    attrs: {
      "selectedCalendarId": _vm.selectedOtherCalendarId
    },
    on: {
      "changed": _vm.setSelectedOtherCalendarId
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.editTask && _vm.getOtherCalendarName(_vm.selectedOtherCalendarId)) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['created_in_calendar']))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getOtherCalendarName(_vm.selectedOtherCalendarId)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "initialColor": _vm.color
    },
    on: {
      "changedColor": _vm.setColor
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__submit"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }, [(_vm.editTask) ? [(_vm.usersWithEvents.length < 1) ? _c('button', {
    staticClass: "hint--right bttn--warning",
    attrs: {
      "aria-label": "Slet opgaven"
    },
    on: {
      "click": _vm.deleteTask
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['cannot_be_deleted']
    }
  }, [_c('button', {
    staticClass: "bttn bttn--disabled"
  }, [_c('span', {
    staticClass: "icon-bin"
  })])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "marg-1-right do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (!_vm.editTask) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingTask
    },
    on: {
      "click": _vm.createTask
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_task']) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editTask) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingTask
    },
    on: {
      "click": _vm.updateTask
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_task']) + "\n              ")]) : _vm._e()])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-overlay animatedFast fadeIn"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9a6245c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasksCreate.vue
// module id = 1788
// module chunks = 1